import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const GENERATE_UPLOAD_URL_MUTATION = mutation({
  generateUploadUrl: [
    { input: input('input', 'GenerateUploadUrlInput!') },
    {
      presignedUrl: true,
      key: true,
    },
  ],
});

type GenerateUploadUrlInputType = VariablesOf<typeof GENERATE_UPLOAD_URL_MUTATION>['input'];
type GenerateUploadUrlResponseType = ResultOf<typeof GENERATE_UPLOAD_URL_MUTATION>['generateUploadUrl'];

export const generateUploadUrlMutationRequest = async (
  props: GenerateUploadUrlInputType
): Promise<ResultType<GenerateUploadUrlResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(GENERATE_UPLOAD_URL_MUTATION, { input: props }, { useAuth: true });

  return {
    success: Boolean(response?.generateUploadUrl?.presignedUrl),
    data: response?.generateUploadUrl ?? { presignedUrl: null, key: null },
  };
};
